module.exports = __webpack_public_path__ + "static/img/top-img4.c626959.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top-img4.png
// module id = ImH2
// module chunks = 0